import { render, staticRenderFns } from "./ScoreboardReportStatus.vue?vue&type=template&id=4334d5df&"
import script from "./ScoreboardReportStatus.vue?vue&type=script&lang=ts&"
export * from "./ScoreboardReportStatus.vue?vue&type=script&lang=ts&"
import style0 from "./ScoreboardReportStatus.vue?vue&type=style&index=0&id=4334d5df&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports